var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    stroke: "#777777",
    strokeOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 26.5L27.942 28.2394C29.6572 29.2535 30.3428 29.2535 32.058 28.2394L35 26.5",
    stroke: "#297A53",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0158 31.4756C20.0811 34.5411 20.1138 36.0739 21.245 37.2093C22.3761 38.3448 23.9503 38.3843 27.0988 38.4634C29.0393 38.5122 30.9607 38.5122 32.9012 38.4634C36.0497 38.3843 37.6239 38.3448 38.755 37.2093C39.8862 36.0739 39.9189 34.5411 39.9842 31.4756C40.0053 30.4899 40.0053 29.51 39.9842 28.5244C39.9189 25.4589 39.8862 23.9261 38.755 22.7907C37.6239 21.6552 36.0497 21.6157 32.9012 21.5366C30.9607 21.4878 29.0393 21.4878 27.0988 21.5366C23.9503 21.6157 22.3761 21.6552 21.245 22.7907C20.1138 23.9261 20.0811 25.4589 20.0158 28.5243C19.9947 29.51 19.9947 30.4899 20.0158 31.4756Z",
    stroke: "#297A53",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBox);
export default __webpack_public_path__ + "static/media/email-box.5cfeb5d83701be388f8bf39647f2d6be.svg";
export { ForwardRef as ReactComponent };